/* RESPONSIBLE TEAM: team-frontend-tech */
import Block from './block';
import { attr } from '@ember-data/model';

export default class IfElseStatement extends Block {
  @attr fallbackBlocks;
  @attr predicatesBlocksPairs;
}
